var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("sfe.CPPerformanceReport.BoxWrap.manage") },
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "visiting",
                    label: _vm.$t("sfe.CPPerformanceReport.tab.visiting"),
                  },
                },
                [
                  _c("Visiting", {
                    ref: "visitingRef",
                    attrs: {
                      rsmList: _vm.RSMList,
                      comment: _vm.addCommentByRow,
                      assignTasks: _vm.assignTasks,
                      exportReport: _vm.exportReport,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "visitPlan",
                    label: _vm.$t("sfe.CPPerformanceReport.tab.visitPlan"),
                  },
                },
                [
                  _c("VisitPlan", {
                    ref: "visitPlanRef",
                    attrs: {
                      rsmList: _vm.RSMList,
                      comment: _vm.addCommentByRow,
                      assignTasks: _vm.assignTasks,
                      exportReport: _vm.exportReport,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "customerDistribution",
                    label: _vm.$t(
                      "sfe.CPPerformanceReport.tab.customerDistribution"
                    ),
                  },
                },
                [
                  _c("CustomerDistribution", {
                    ref: "customerDistributionRef",
                    attrs: {
                      rsmList: _vm.RSMList,
                      comment: _vm.addCommentByRow,
                      assignTasks: _vm.assignTasks,
                      exportReport: _vm.exportReport,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "networkExpansion",
                    label: _vm.$t(
                      "sfe.CPPerformanceReport.tab.networkExpansion"
                    ),
                  },
                },
                [
                  _c("NetworkExpansion", {
                    ref: "networkExpansionRef",
                    attrs: {
                      rsmList: _vm.RSMList,
                      comment: _vm.addCommentByRow,
                      assignTasks: _vm.assignTasks,
                      exportReport: _vm.exportReport,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCommentDialog
        ? _c("Commment", {
            attrs: {
              visible: _vm.showCommentDialog,
              "current-row": _vm.currentRow,
            },
            on: {
              submit: _vm.submitCommentDialog,
              close: _vm.closeCommentDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AssignTasks", { ref: "AssignTasks" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }